import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles({
  list: {
    width: 400,
  },
  fullList: {
    width: 'auto',
  },
  buttonLink: {
    marginTop: 15,
    marginRight: 15,
    textTransform: 'none',
  },
  backBtn: {
    marginLeft: 15,
    textTransform: 'none',
    marginTop: 15,
    color: '#9e9e9e',
  },
  popoverPaper: {
    borderRadius: 10,
    border: 1,
    borderStyle: 'solid',
    borderColor: 'red',
  },
})

export default useStyles
